import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import KnowledgeEnrichmentTurnSignalsAPI from '../../api/knowledgeEnrichmentTurnSignals';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  meta: { totalCount: 0, page: 1 },
  uiFlags: {
    isFetching: false,
    isUpdating: false,
  },
};

export const getters = {
  getTurnSignals($state) {
    return $state.records;
  },
  getMeta($state) {
    return $state.meta;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

// Accept / Dismiss: the reviewed turn leaves the list being shown.
const review = async (commit, request, id) => {
  commit(types.SET_KE_TURN_SIGNAL_UI_FLAG, { isUpdating: true });
  try {
    await request();
    commit(types.DELETE_KE_TURN_SIGNAL, id);
  } catch (error) {
    throwErrorMessage(error);
  } finally {
    commit(types.SET_KE_TURN_SIGNAL_UI_FLAG, { isUpdating: false });
  }
};

export const actions = {
  index: async ({ commit }, { agentBotId, ...params }) => {
    commit(types.SET_KE_TURN_SIGNAL_UI_FLAG, { isFetching: true });
    try {
      const response = await KnowledgeEnrichmentTurnSignalsAPI.index(
        agentBotId,
        params
      );
      commit(types.SET_KE_TURN_SIGNALS, response.data.payload);
      commit(types.SET_KE_TURN_SIGNALS_META, response.data.meta);
      return response.data.payload;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KE_TURN_SIGNAL_UI_FLAG, { isFetching: false });
    }
  },

  dismiss: ({ commit }, { agentBotId, id }) =>
    review(
      commit,
      () => KnowledgeEnrichmentTurnSignalsAPI.dismiss(agentBotId, id),
      id
    ),

  accept: ({ commit }, { agentBotId, id }) =>
    review(
      commit,
      () => KnowledgeEnrichmentTurnSignalsAPI.accept(agentBotId, id),
      id
    ),
};

export const mutations = {
  [types.SET_KE_TURN_SIGNAL_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_KE_TURN_SIGNALS]: MutationHelpers.set,
  [types.SET_KE_TURN_SIGNALS_META]($state, meta) {
    $state.meta = {
      totalCount: meta.total_count,
      page: meta.page,
    };
  },
  [types.DELETE_KE_TURN_SIGNAL]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
